import React from "react";
import HeroCTR from "../../components/hero/HeroSectionComp";
import AllPackages from "../../containers/home/AllPackagesCTR";
import ReviewCTR from "../../containers/home/ReviewCTR";
import MemberCTR from "../../containers/about/MemberCTR";
import FindAdventureCTR from "../../containers/home/FindAdventureCTR";

function AboutCTR() {
  const whyChooseUsData = [
    {
      icon: "/images/about/w1.png",
      iconWidth: 30,
      title: "Genuine 5-Star Service — Not Just a Claim",
      description:
        "With a perfect 5.0 rating across 60+ verified TripAdvisor reviews, Bonvoy Tourism is one of Dubai's most consistently excellent tour operators. We do not pay for reviews and we do not offer incentives for positive feedback. Every star is earned by delivering exactly what we promise — and then going further.",
    },
    {
      icon: "/images/about/w2.png",
      iconWidth: 30,
      title: "Fully Licensed & Insured by Dubai Tourism Authority",
      description:
        "Every vehicle in our fleet is licensed and regularly inspected by the Dubai Tourism Authority. Every guide holds relevant UAE certifications. Every booking automatically includes complimentary travel insurance for all participants. Your safety is not negotiable — it is built into everything we do.",
    },
    {
      icon: "/images/about/w3.png",
      iconWidth: 30,
      title: "Best Price Guarantee — We Match Any Lower Rate",
      description:
        "Find the identical experience at a lower price anywhere else online and we will match it immediately, no questions asked. We have always offered some of the most competitive rates for desert safaris and city tours in Dubai — because we believe that world-class experiences should be accessible, not exclusive.",
    },
    {
      icon: "/images/about/w4.png",
      iconWidth: 30,
      title: "Zero Hidden Costs — Complete Transparency",
      description:
        "The price shown on your booking confirmation is the price you pay. Hotel pickup, complimentary travel insurance, all activity equipment, safety gear, and guide fees are included in the stated price for your tour package — unless an optional paid add-on is clearly listed as separate. No surprise charges.",
    },
  ];
  return (
    <div>
      <HeroCTR
        img="/images/hero/bg-subheader.jpg"
        // heading="About Bonvoy Tourism"
        // para=" Dubai's 5-Star Rated Tour Operator"
        heading="About Bonvoy Tourism — Dubai's Most Trusted Tour Company"
        para="5.0 ★ Rated · 60+ Five-Star Reviews · Licensed & Insured · Since 2020"
      />

      <div className="mt-12 md:mt-22">
        {/* Section 1 */}
        <div className="flex flex-col md:flex-row gap-4 md:gap-22 items-center justify-between">
          <div
            className="md:flex-1 w-full h-[318px] md:h-[418px] bg-cover bg-top rounded-md"
            style={{ backgroundImage: "url('/images/about/s1.jpg')" }}
          ></div>
          <div className="flex-1">
            <h3 className="text-[20px] md:text-[24px] lg:text-[30px] text-[#666] font-semibold mb-2">
              Who We Are
            </h3>
            <p className="text-[15px] text-[#8C8C8C] max-w-[730px] mb-4">
              Bonvoy Tourism is a Dubai-based tour operator founded with a single, clear purpose: to give every visitor to Dubai an experience that genuinely exceeds their expectations. Not just a tour — an adventure. Not just a guide — a local friend who happens to know everything about the most extraordinary city on earth.</p>
            <p className="text-[13px] text-[#606060] max-w-[730px] mb-4">
              We are a deliberately small team. We believe the best travel experiences come from people who are genuinely passionate about what they do — not from large, anonymous operations where guests are just a booking reference number. At Bonvoy Tourism, every desert safari is led by a guide who cares deeply about your experience, every vehicle in our fleet meets Dubai Tourism Authority licensing standards, and every booking is handled personally.</p>
            <p className="text-[13px] text-[#606060] max-w-[730px]">
              We are based in Dubai, UAE, at Al Saqar Business Tower, Office 117, Sheikh Zayed Road, DIFC. Reach us 24/7 on
              {" "}
              <a
                href="https://wa.me/971559215470"
                target="_blank"
                rel="noopener noreferrer"
                className="text-[#606060] hover:text-[#ff9219] transition"
              >
                +971-55-9215470
              </a>
              {" "}
              via phone or WhatsApp, or at
              {" "}
              <a
                href="mailto:contact@bonvoytourism.com"
                className="text-[#606060] hover:text-[#ff9219] transition"
              >
                contact@bonvoytourism.com
              </a>
              .
            </p>
          </div>
        </div>

        {/* Section 2 */}
        <div className="flex flex-col-reverse md:flex-row gap-4 md:gap-22 items-center justify-between mt-4 md:mt-0">
          <div className="flex-1">
            <h3 className="text-[20px] md:text-[24px] lg:text-[30px] text-[#666] font-semibold mb-2">
              Our Story — Why Bonvoy Tourism Exists
            </h3>
            <p className="text-[15px] text-[#8C8C8C] max-w-[730px] mb-4">
              Bonvoy Tourism was born from a genuine frustration. Our founders had witnessed too many visitors to Dubai leaving disappointed after their desert safari — overcrowded Bedouin camps where guests sat shoulder-to-shoulder with strangers, indifferent guides who spent the evening on their phones, vehicles that had seen better days, and BBQ food that nobody would choose if they had a real option.
            </p>
            <p className="text-[13px] text-[#606060] max-w-[730px] mb-4">
              Starting with a single vehicle and an unshakeable commitment to doing things right, Bonvoy Tourism grew entirely through word of mouth — through five-star TripAdvisor reviews, through guests who returned the following year, and through the kind of reputation that can only be built by genuinely looking after people. There were no paid advertisements, no fake reviews, no shortcuts.
            </p>
            <p className="text-[13px] text-[#606060] max-w-[730px]">
              Today, Bonvoy Tourism is ranked in the top 9% of outdoor activity and attraction providers in all of Dubai. We offer 17 tours and UAE experiences covering everything from the iconic Lahbab Red Dunes to the ancient heritage sites of Al Ain, from a private dhow cruise along Dubai Creek to a full-day journey across all six northern emirates. And we are just getting started.
            </p>
          </div>
          <div
            className="md:flex-1 w-full h-[318px] md:h-[418px] bg-cover bg-top rounded-md"
            style={{ backgroundImage: "url('/images/about/s3.jpg')" }}
          ></div>
        </div>
      </div>

      {/* Section 3 */}
      <div className="flex flex-col md:flex-row gap-4 md:gap-22 items-center justify-between mt-4 md:mt-0">
        <div
          className="md:flex-1 w-full h-[318px] md:h-[418px] bg-cover bg-top rounded-md"
          style={{ backgroundImage: "url('/images/about/s2.jpg')" }}
        ></div>
        <div className="flex-1">
          <h3 className="text-[20px] md:text-[24px] lg:text-[30px] text-[#666] font-semibold mb-2">
            Our Mission
          </h3>
          <p className="text-[15px] text-[#8C8C8C] max-w-[730px] mb-4">
            "Our mission is to be the tour operator we would want to book with if we were visiting Dubai for the very first time." </p>
          <p className="text-[13px] text-[#606060] max-w-[730px] mb-4">
            Honest, transparent pricing — the price you see is the price you pay, with no hidden charges at checkout
            Genuine local expertise — guides who have lived in Dubai for years and know it like the back of their hand
            Experiences that feel personal — small groups, private vehicles, and itineraries built around what you actually want
            Memories that last long after the trip ends — moments you will talk about for years, not just hours
            A standard of service that raises the bar for tourism in Dubai — not just meeting expectations, but exceeding them every single time
          </p>
          <p className="text-[13px] text-[#606060] max-w-[730px]">
            We do not measure success by the number of tours we run. We measure it by the number of guests who tell their friends to book with Bonvoy Tourism the moment they get home.
          </p>
        </div>
      </div>

      {/* <div className="mt-12 md:mt-22">
        <h3 className="text-[20px] md:text-[24px] lg:text-[30px] text-[#666] font-semibold mb-4">
          What Makes Us Different
        </h3>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {whyChooseUsData.map((item, index) => (
            <div
              className={`shadow-md rounded-md p-5 bg-[#f9f9f9] ${index === whyChooseUsData.length - 1 ? "lg:col-span-3" : ""
                }`}
            >
              <div className=" h-full">
                <div className="flex flex-col justify-between h-full min-h-[200px]">
                  <div className="flex items-center">
                    <div className="bg-white p-3 shadow-md rounded-md">
                      <img
                        src={item.icon}
                        alt={item.title}
                        width={item.iconWidth}
                        height={item.iconWidth}
                      />
                    </div>
                  </div>
                  <div>
                    <p className="text-[15px] font-semibold text-[#4E4E4E] max-w-[730px] mb-2">
                      {item.title}
                    </p>

                    <p className="text-[13px] font-medium text-[#606060] max-w-[730px]">
                      {item.description}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div> */}
      <div className="mt-12 md:mt-22">
        <h3 className="text-[20px] md:text-[24px] lg:text-[30px] text-[#666] font-semibold mb-6">
          What Makes Bonvoy Tourism Different
        </h3>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-stretch">

          <div className="lg:col-span-6 order-2 lg:order-1">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 h-full">

              {whyChooseUsData.map((item, index) => (
                <div
                  key={index}
                  className="shadow-md rounded-xl p-5 bg-[#f9f9f9]"
                >
                  <div className="flex flex-col justify-between h-full min-h-[220px]">

                    <div className="flex items-center mb-[20px] md:mb-[0px] lg:mb-[20px]">
                      <div className="bg-white p-3 shadow-md rounded-md">
                        <img
                          src={item.icon}
                          alt={item.title}
                          width={item.iconWidth}
                          height={item.iconWidth}
                        />
                      </div>
                    </div>

                    <div>
                      <p className="text-[17px] font-semibold text-[#4E4E4E] mb-3">
                        {item.title}
                      </p>

                      <p className="text-[14px] leading-[24px] font-medium text-[#606060]">
                        {item.description}
                      </p>
                    </div>

                  </div>
                </div>
              ))}

            </div>
          </div>

          <div className="lg:col-span-6 order-1 lg:order-2">
            <div className="relative rounded-2xl overflow-hidden shadow-md h-full min-h-[500px]">

              <img
                src="/images/about/provide.jpg"
                alt="Dubai Desert Safari"
                className="w-full h-full object-cover absolute inset-0"
              />

              <div className="absolute inset-0 bg-black/20"></div>

              <div className="absolute bottom-8 left-4 lg:left-8 text-white z-10">
                <h4 className="text-[20px] md:text-[24px] lg:text-[28px] font-bold mb-2">
                  Experience Dubai Like Never Before
                </h4>

                <p className="text-[15px] max-w-[400px] leading-[24px]">
                  Premium desert adventures, luxury experiences and unforgettable memories.
                </p>
              </div>

            </div>
          </div>
        </div>
      </div>

      <div className="-mx-6 sm:-mx-10 md:-mx-14 lg:-mx-20">
        <AllPackages />
      </div>

      <ReviewCTR />

      <div className="-mx-6 sm:-mx-10 md:-mx-14 lg:-mx-20">
        <MemberCTR />
      </div>

      <div className="-mx-6 sm:-mx-10 md:-mx-14 lg:-mx-20">
        <FindAdventureCTR mt="mt-12 md:mt-22" />
      </div>
    </div>
  );
}

export default AboutCTR;
